import React from "react";
import EmptyStateCard from "../../../components/shared/EmptyStateCard";
import PageHero from "../../../components/shared/PageHero";
import SummaryMetricCard from "../../../components/shared/SummaryMetricCard";
import RichiesteService from "../../../services/RichiesteService";
import SellerRequestCard from "../../../components/marketplace/seller/SellerRequestCard";
import { getDateSortValue } from "../../../utils/date";
import { isRichiestaExpired } from "../../../utils/richiestaExpiry";
import "../../../styles/screens/marketplace/seller/RichiesteRicevute.css";

class RichiesteRicevute extends React.Component {
  state = {
    richieste: [],
    isLoading: true,
    error: "",
  };

  componentDidMount() {
    this.loadRichieste();
  }

  componentDidUpdate(prevProps) {
    if (Boolean(prevProps.showStorico) !== Boolean(this.props.showStorico)) {
      this.loadRichieste();
    }
  }

  loadRichieste = async () => {
    const isStoricoMode = Boolean(this.props.showStorico);
    this.setState({
      isLoading: true,
      error: "",
    });

    try {
      const response = await RichiesteService.list({
        view: isStoricoMode ? "history" : "active",
      });

      this.setState({
        richieste: (Array.isArray(response?.items) ? response.items : []).sort(
          (left, right) => getDateSortValue(right?.createdAt) - getDateSortValue(left?.createdAt)
        ),
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        richieste: [],
        isLoading: false,
        error: "Impossibile caricare le richieste ricevute. Riprova tra poco.",
      });
    }
  };

  render() {
    const { richieste, isLoading, error } = this.state;
    const isStoricoMode = Boolean(this.props.showStorico);
    const richiesteAttive = richieste.filter((item) => !isRichiestaExpired(item));
    const richiesteStorico = richieste.filter((item) => isRichiestaExpired(item));
    const richiesteVisibili = isStoricoMode ? richiesteStorico : richiesteAttive;
    const richiesteScadute = richiesteStorico.length;

    return (
      <div className="seller-shell">
        <main className="seller-main">
          <PageHero
            className="seller-hero"
            eyebrow="Dashboard venditore"
            title={isStoricoMode ? "Storico richieste" : "Richieste ricevute"}
            description={
              isStoricoMode
                ? "Richieste scadute senza processo avviato."
                : "Riepilogo delle istanze attive pervenute da parte dei clienti."
            }
          />

          <section className="seller-summary marketplace-summary-grid marketplace-summary-grid--three">
            <SummaryMetricCard label="Richieste totali" value={richieste.length} className="seller-summary__card" />
            <SummaryMetricCard label="Con offerte" value={richieste.filter((item) => item.offerte?.length > 0).length} className="seller-summary__card" />
            <SummaryMetricCard label="Scadute (24h)" value={richiesteScadute} className="seller-summary__card" />
          </section>

          <section className="seller-list">
            {error ? <div className="alert alert-danger">{error}</div> : null}

            {isLoading ? (
              <EmptyStateCard
                className="seller-empty-state"
                icon="fa-circle-o-notch"
                spin={true}
                title="Caricamento richieste"
                description="Stiamo recuperando le richieste assegnate al tuo profilo venditore."
              />
            ) : null}

            {!isLoading && !error && richiesteVisibili.length === 0 ? (
              <EmptyStateCard
                className="seller-empty-state"
                icon={isStoricoMode ? "fa-archive" : "fa-envelope-open-o"}
                title={isStoricoMode ? "Storico vuoto" : "Nessuna richiesta attiva"}
                description={
                  isStoricoMode
                    ? "Le richieste scadute compariranno qui."
                    : "Quando il marketplace ti assegnera nuove richieste, compariranno qui."
                }
              />
            ) : null}

            {!isLoading && !error
              ? richiesteVisibili.map((richiesta) => (
                  <SellerRequestCard key={richiesta.id} richiesta={richiesta} />
                ))
              : null}
          </section>
        </main>
      </div>
    );
  }
}

export default RichiesteRicevute;





